<template>
	<div class="userHome">
		<div class="navhengfu"><span class="navtxt" >没券看方案？不存在的，注册就送！注册就送！注册就送！赢体育YYDS！</span></div>
		
		<!--<div class="notice">
			<div style="width: 100%;display: flex;cursor: pointer;">
				<el-carousel class="lunbo" height="35" direction="vertical">
					<div style="display: flex;align-items: center;justify-content: right;margin-right: 482px;"><img src="@/static/icons/noticeIcon.png" alt=""><span>公告：</span></div>
					<el-carousel-item v-for="(item, index) in ruleTipLists" :key="index">
						<span @click="ruleShow(index)">{{ item }}</span>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>-->
		<div class="main">
			<div class="topicBox">
				<div class="topicsCent">
					<div class="topicsCentLeft">
						<img :src="UsersInfo.thumb?pubImg(UsersInfo.thumb):require('@/static/img/defaultAvatar.png')" alt="">
						<span class="name" :title="UsersInfo.username">{{UsersInfo.username}}</span>
					</div>
					<div class="topicsCentRight" v-if="UsersInfo.recode">
						<div class="detail">
							{{UsersInfo.recode.domain?UsersInfo.recode.domain:'暂无介绍~'}}
						</div>
						
						<div class="boxText">
							<div style="line-height: 22px;text-align: left;" v-if="UsersInfo.recode">
								<div class="match" v-if="UsersInfo.recode.last_ten">近10走势：远
									<span v-for="(tenVal,tenInd) in UsersInfo.recode.last_ten" :key="tenInd" :style="'background-color:'+ tenBgColor(tenVal) +';'">{{tenVals(tenVal)}}</span>
								<!-- DDDDDDD -->
								近</div>
								<!-- {{UsersInfo.recode.saveTag}} -->
								<div class="match" v-if="!UsersInfo.recode.last_ten">近10走势：远 -- 近</div>
								<div class="saveTagBox" v-if="UsersInfo.recode.saveTag.length!=0">
									<span v-for="(val,key,i) in UsersInfo.recode.saveTag" :class="saveTagBg(key)" v-if="val">{{ val }}</span>
									<!-- {{saveTab(UsersInfo.saveTag)}} -->
								</div>
							</div>
							<div class="topicsCentNav">
								<div>粉丝：<span>{{UsersInfo.fans}}</span></div>
								<div>点赞：<span>{{UsersInfo.recode.likes}}</span></div>
								<div :class="uidStatus(UsersInfo.id)?'grcyInterest':''" @click="interest(UsersInfo.id,'user')">{{uidStatus(UsersInfo.id)?'已关注':'@关注'}}</div>
							</div>
						</div>
					</div>
					
				</div>
				<div class="userNav">
					<div class="tabs">
						<span :class="outIndex==newOutIndex?'isSecte':''" v-for="(outItem,outIndex) in outNav" :key="outIndex" @click="changeOutInd(outIndex)">{{outItem}}</span>
					</div>
					<div class="gameTopicList"  id="scroll-container">
						<div v-if="newOutIndex<2" >
							<div class="gameTopicItem" v-if="tiebaList"  v-for="(tiebaItem,tiebaIndex) in tiebaList" :key="tiebaIndex" @click="toArticlePage(tiebaItem.cid)">
								<div class="outbox">
									<img class="userImg" :src="require('@/static/icons/sport'+tiebaItem.sportId+'.png')" alt="">
									<div class="gameTopicCent">
										<div class="gameCentTitle">
											<el-tag :type="tiebaItem.kind==1?'info':
												tiebaItem.kind==2?'danger':
												tiebaItem.kind==3?'waring':''" effect="plain" size="small">
												{{ tiebaItem.kind==1?'让球':
												tiebaItem.kind==2?'大小球':
												tiebaItem.kind==3?'胜负平':'竞彩让球' }}
											</el-tag>
											<span> {{tiebaItem.title}}</span>
										</div>
										<div class="gameCentNum">
											<span :style="'background-color:'+ tiebaItem.match_type_color +';'">{{tiebaItem.match_type_name}}</span>
											<span>{{new Date().toDate(tiebaItem.match_play_datetime)}}</span>
											<el-divider color="#B6CBF0" direction="vertical"></el-divider>
											<span @click.stop @click="toGameTieba(tiebaItem.match_id)">{{tiebaItem.x_team_name}} VS {{tiebaItem.y_team_name}}</span>
											<el-divider color="#B6CBF0" direction="vertical"></el-divider>
											<span @click.stop @click="toTiebaDetails(tiebaItem.pid)">{{tiebaItem.pubname}}</span>
											<el-divider color="#B6CBF0" direction="vertical"></el-divider>
											<span>发布于{{new Date().toaddtime(tiebaItem.create_time)}}</span>
											<el-divider color="#B6CBF0" direction="vertical"></el-divider>
											<span>{{isFreeText(tiebaItem.is_free)}}</span>
										</div>
									</div>
									<img style="width: 55px;height: 55px;image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */" v-if="tiebaItem.mrs!=0" :src="require('@/static/icons/mrs'+tiebaItem.mrs+'.png')" alt="" />
								</div>
								<div>
								<div class="watchNum" v-if="tiebaItem.is_free == 0">
									
									<a class="paycoin" v-if="tiebaItem.is_free==0" >免费福利</a>
								</div>
								<div class="lookcoin" v-if="tiebaItem.is_free != 0">
									<!--<span>{{tiebaItem.coins}}查看</span>-->
									<a class="paycoin" v-if="tiebaItem.is_free!=0" :style="tiebaItem.looks!=0 ? 'top:36%' : 'top:18%' ">需要{{tiebaItem.coins}}Y币<font v-if="tiebaItem.looks!=0"><br/>已有<b style="color:red" > {{tiebaItem.looks}} </b>解锁</font></a>
								</div>
									
								</div>
							</div>
							<div v-else class="emtype">
								<img src="@/static/icons/empty.png" alt="">
								<div>暂无数据</div>
							</div>
							<div v-if="loading" v-html="loadingstr"></div>
							
		
						</div>
						
						<!--<div v-if="newOutIndex==1" class="myAttentionBox">
							<div class="myAttentionItem" v-if="tiebaAttention.length!=0"  v-for="(tiebaAttentItem,tiebaAttentIndex) in tiebaAttention" :key="tiebaAttentIndex"  @click="toTiebaDetails(tiebaAttentItem.pid)">
								<img :src="tiebaAttentItem.thumb?pubImg(tiebaAttentItem.thumb):require('@/static/img/defaultAvatar.png')" class="tiebaImg" alt="">
								<div class="tiebaBox">
									<div class="tiebaName">{{tiebaAttentItem.name}}</div>
									<div class="tiebaNum">{{tiebaAttentItem.domain}}</div>
								</div>
								<div  @click.stop :class="['takeOff',numStatus(tiebaAttentItem.pid)?'grcyInterest':'']" @click="interest(tiebaAttentItem.pid,'pub')">{{numStatus(tiebaAttentItem.pid)?'已关注':'+ 关注'}}</div>
							</div>
							<div v-else class="emtype">
								<img src="@/static/icons/empty.png" alt="">
								<div>暂无数据</div>
							</div>
						</div>-->
						<div v-if="newOutIndex==2" class="myAttentionBox">
							<div class="myAttentionItem" v-if="userAttention"  v-for="(userAttentItem,userAttentIndex) in userAttention" :key="userAttentIndex" @click="toUserHome(userAttentItem.id)">
								<img :src="userAttentItem.thumb?pubImg(userAttentItem.thumb):require('@/static/img/defaultAvatar.png')" class="tiebaImg" alt="">
								<div class="tiebaBox">
									<div class="tiebaName">{{userAttentItem.username}}</div>
									<div class="tiebaNum">{{userAttentItem.domain?userAttentItem.domain:'暂无介绍~'}}</div>
								</div>
								<div @click.stop :class="['takeOff',uidStatus(userAttentItem.id)?'grcyInterest':'']" @click="interest(userAttentItem.id,'user')">{{uidStatus(userAttentItem.id)?'已关注':'+ 关注'}}</div>
							</div>
							<div v-if="tiebaList.length==0 && userAttention.length==0" class="emtype">
								<img src="@/static/icons/empty.png" alt="">
								<div>暂无数据</div>
							</div>
						</div>
						<div v-if="newOutIndex==3" class="billboardbox">
							<div class="myGuessBox" v-if="ballBoxItem.a||ballBoxItem.b">
								<div class="statisticsList">
									<div class="title">命中率统计</div>
									<div class="selectList">
										<span :class="ballTypes=='week'?'isCli':''" @click="changeCount('week')">周命中率</span>
										<span :class="ballTypes=='month'?'isCli':''" @click="changeCount('month')">月命中率</span>
										<span :class="ballTypes=='qua'?'isCli':''" @click="changeCount('qua')">季命中率</span>
									</div>
								</div>
								<div class="ballBox" v-if="ballBoxItem.a.match_count">
									<span>让球</span>
									<span>{{ballBoxItem.a.match_count}}场 /  胜  <span>{{ballBoxItem.a.win_count}}</span>  走  <span>{{ballBoxItem.a.ping_count}}</span>  负   <span>{{ballBoxItem.a.lost_count}}</span></span>
									<span>命中率</span>
									<span class="progree"><el-progress :percentage="count(ballBoxItem.a.win_count,(ballBoxItem.a.match_count-ballBoxItem.a.ping_count))"></el-progress></span>
								</div>
								<div class="ballBox" v-if="ballBoxItem.b.match_count">
									<span>大小</span>
									<span>{{ballBoxItem.b.match_count}}场 /  胜  <span>{{ballBoxItem.b.win_count}}</span>  走  <span>{{ballBoxItem.b.ping_count}}</span>  负   <span>{{ballBoxItem.b.lost_count}}</span></span>
									<span>命中率</span>
									<span class="progree twoPro"><el-progress :percentage="count(ballBoxItem.b.win_count,(ballBoxItem.b.match_count-ballBoxItem.b.ping_count))"></el-progress></span>
								</div>
								<div class="circleProgree" v-if="(Number(ballBoxItem.a.match_count+ballBoxItem.b.match_count))!=0">
									<div class="ProBox">
										<el-progress type="circle" :show-text="false" color="#02ce38" :stroke-width="20" :percentage="circleBgProVal"></el-progress>
										<el-progress type="circle"  class="circleProBg" :show-text="false" color="#0000ff" :stroke-width="20" :percentage="circleMiddleProVal"></el-progress>
										<el-progress class="circleProBg" :show-text="false" type="circle" color="#ff0000" :stroke-width="20" :percentage="circleProVal"></el-progress>
										 <!-- 环形进度条的文本内容 -->
										<div class="text-wrap">
										    <div class="text-content">
										        <span class="big-font">{{circleProVal}}</span>%
										        <p class="font-light">总命中率</p>
										    </div>
										</div>
									</div>
									<div class="circleBox" v-if="ballBoxItem.a||ballBoxItem.b">
										<div><span>总</span>{{Number(ballBoxItem.a.match_count)+Number(ballBoxItem.b.match_count)}}场</div>
										<div><span>中</span>{{Number(ballBoxItem.a.win_count)+Number(ballBoxItem.b.win_count)}}场</div>
									</div>
								</div>
								<div v-else class="emtype">
									<img src="@/static/icons/noData.png" alt="">
								</div>
							</div>
							<div class="billboardItem">
								<div class="BillboardTitle">参与详细</div>
								<div class="BillboardNav">
									<span>赛事</span>
									<span>时间</span>
									<span>主队</span>
									<span>比分</span>
									<span>客队</span>
									<span>详细</span>
								</div>
								<div class="BillboardTable">
									<div class="BillboardItem"  v-for="(UserGuessItem,UserGuessIndex) in UserGuess" v-if="UserGuess" v-show="UserGuessItem.lodds_cn" :key="UserGuessIndex">
										<span :style="'background-color:'+ UserGuessItem.match_type_color +';'">{{UserGuessItem.match_type_name}}</span>
										<span>{{new Date().toNewDate(UserGuessItem.match_play_datetime)}}</span>
										<span>{{UserGuessItem.x_team_name}}</span>
										<!-- <span> -->
											<span v-if="UserGuessItem.status==-1">比赛取消</span>
											<span v-if="UserGuessItem.status!=-1">{{UserGuessItem.x_goal}} - {{UserGuessItem.y_goal}}</span>
										<!-- </span> -->
										<span>{{UserGuessItem.y_team_name}}</span>
										<span>{{textRep(UserGuessItem.lodds_cn)}}</span>
										<!-- <span v-if="UserGuessItem.is_pay == 0">
										  <span v-if="UserGuessItem.mrs==0" style="color: #000;">{{UserGuessItem.kind==1?(UserGuessItem.rtype==1?UserGuessItem.x_team_name:UserGuessItem.y_team_name):(UserGuessItem.rtype==1?'大':'小')}}</span>
										    <span v-else :style="'color:'+ mrs(UserGuessItem.mrs) +';'">{{UserGuessItem.kind==1?(UserGuessItem.rtype==1?UserGuessItem.x_team_name:UserGuessItem.y_team_name):(UserGuessItem.rtype==1?'大':'小')}}</span>
										</span>
										<span v-if="UserGuessItem.is_pay == 1">
										  <span v-if="UserGuessItem.mrs==0&UserGuessItem.isPay!=1"><el-button @click="isLook(UserGuessItem.id)" type="primary" round size="small">查看</el-button></span>
										    <span v-else :style="'color:'+ mrs(UserGuessItem.mrs) +';'">{{UserGuessItem.kind==1?(UserGuessItem.rtype==1?UserGuessItem.x_team_name:UserGuessItem.y_team_name):(UserGuessItem.rtype==1?'大':'小')}}</span>
										</span> -->
										<!-- {{ (userInfo?(userInfo.id==uid):'') }} -->
										<span v-if="UserGuessItem.is_pay == 1 & UserGuessItem.mrs==0">
											<el-button v-if="UserGuessItem.isPay!=1 & (userInfo?(userInfo.id!=uid):true) " @click="isLook(UserGuessItem.id)" type="primary" round size="small">查看</el-button>
											<span v-else :class="UserGuessItem.is_import==1?'isImp':''" :style="'color:'+ mrs(UserGuessItem.mrs) +';display: inline-block;width: 100%;'">{{UserGuessItem.kind==1?(UserGuessItem.rtype==1?UserGuessItem.x_team_name:UserGuessItem.y_team_name):(UserGuessItem.rtype==1?'大':'小')}}({{UserGuessItem.lodds}})</span>
										</span>
										<span v-else :class="UserGuessItem.is_import==1?'isImp':''" :style="'color:'+ mrs(UserGuessItem.mrs) +';'">{{UserGuessItem.kind==1?(UserGuessItem.rtype==1?UserGuessItem.x_team_name:UserGuessItem.y_team_name):(UserGuessItem.rtype==1?'大':'小')}}({{UserGuessItem.lodds}})</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 登录弹框 -->
		<div class="loginShow">
			<el-dialog title="用户登录" @close="loginClose" :visible.sync="loginDialog" top="20vh">
			  <el-form class="formCent" :model="ruleForm" status-icon ref="ruleForm" label-width="0" @submit.native.prevent="() => submitForm()">
			    <el-form-item prop="username">
			      <el-input placeholder="请输入用户名或手机号" v-model="ruleForm.username" autocomplete="off">
			  		<template slot="prefix"><img src="@/static/icons/userIcon.png" class="icons" alt=""></template>
			  	</el-input>
			    </el-form-item>
			    <el-form-item prop="password">
			      <el-input type="password" placeholder="请输入密码" v-model="ruleForm.password" autocomplete="off">
			  		<template slot="prefix"><img src="@/static/icons/pwdIcon.png" class="icons" alt=""></template>
			  	</el-input>
			    </el-form-item>
			    <el-form-item prop="AuthCode" class="phoneCode">
			  		<el-input placeholder="验证码" v-model="ruleForm.AuthCode">
			  			<template slot="prefix"><img src="@/static/icons/codeIcon.png" class="icons" alt=""></template>
			  			<template slot="suffix"><img :src="captchaImg" alt="" @click="getCaptcha()"></template>
			  		</el-input>
			    </el-form-item>
				<el-form-item prop="AuthCode" class="phoneBox" v-if="phoneCapShow">
				<el-input placeholder="手机验证码" v-model="phone.vcode">
					<template slot="prefix"><img src="@/static/icons/codeIcon.png" class="icons" alt=""></template>
					<template slot="suffix"><div class="phoneCap" @click="codeText=='获取验证码'?getCode():''">{{codeText}}</div></template>
				</el-input>
				</el-form-item>
			    <el-form-item>
			      <el-button type="primary" native-type="submit" class="loginBtn">登录</el-button>
			  	<div class="forgotPwd">忘记密码？</div>
			  	<div class="toRegister" @click="toRegister">还没有账号？<span>去注册</span></div>
			    </el-form-item>
			  </el-form>
			</el-dialog>
			<el-dialog title="登录/注册" @close="loginClose" :visible.sync="telDialog" top="20vh">
				<el-form class="formCent" :model="ruleTelForm" status-icon ref="ruleTelForm" label-width="0" @submit.native.prevent="() => submitTel()">
					<el-form-item prop="tel">
					<el-input placeholder="请输入手机号" v-model="ruleTelForm.tel" autocomplete="off">
						<template slot="prefix"><img src="@/static/icons/userIcon.png" class="icons" alt=""></template>
					</el-input>
					</el-form-item>
					<el-form-item prop="vcode" class="phoneBox">
					<el-input placeholder="手机验证码" v-model="ruleTelForm.vcode">
						<template slot="prefix"><img src="@/static/icons/codeIcon.png" class="icons" alt=""></template>
						<template slot="suffix"><div class="phoneCap" @click="codeText=='获取验证码'?getCode():''">{{codeText}}</div></template>
					</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" native-type="submit" class="loginBtn">登录/注册</el-button>
						<div class="forgotPwd" @click="changelog">密码登录</div>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
		<!-- 兑换Y币 -->
		<div class="payshow" v-if="userInfo">
		    <el-dialog title="兑换Y币" @close="payClose" :visible.sync="payDialog" top="20vh">
		      <div>您还剩余的元宝：<span>{{userInfo.amount_c}}</span> 您剩余Y币：<span>{{userInfo.amount}}</span><a v-if="userInfo.amount_c=='0.00'" @click="toRecharge">去充值</a></div>
		      <div>将 <input style="width: 120px;" v-model="coins" placeholder="请输入兑换数量" @input="coinsChange" /> 元宝进行兑换，获得Y币<span>{{coins}}</span></div>
			  <el-button class="loginBtn" @click="payClose">取 消</el-button>
		      <el-button type="primary" @click="submitPay" class="loginBtn">确认兑换</el-button>
			  <div class="detailBox">
				  <p>关于Y江湖网站Y币和元宝的区别和作用</p>
				  <p>Y币：用户充值后，得到的Y币仅用于Y江湖网站的消费，如解锁收费方案、打赏作者以及查看Y猜球的竞猜方案。Y币只能用于消费，不能提现。</p>
				  <p>元宝：作者在Y江湖网站的收入为元宝，来源于编写收费方案被解锁、获得打赏和Y猜球竞猜方案被付费查看。元宝可提现，也可兑现为Y币。</p>
			  </div>
			  <div>兑换代表您已同意<span>《付费阅读协议》</span></div>
		    </el-dialog>
		</div>
		<div class="ruleShow">
			<el-dialog
			  :visible.sync="isRuleShow"
			  width="600px">
			  <div v-html="ruleVal"></div>
			  <span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="isRuleShow = false">关 闭</el-button>
			  </span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import http from "@/api/http.js";
	import Pagination from "@/components/Pagination.vue";
	export default {
		created() {
			this.$emit('changeIsShow','true');
			this.uid = this.$route.query.uid;
			this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			this.getUsersInfo();
			this.getGuessCount()
			if (this.$route.query.ind) {
				this.newOutIndex = this.$route.query.ind
				this.getUserGuess()
			}else {
				this.getTiebaList()
			}
		},
		data() {
			return {
				activeName: 'first',
				currentTabList:['新注册会员将赠送3天VIP体验卡(10次方案查看,历史方案免费查看)','在赢体育获得的收益，在缴纳8%个人所得税后，用户最高可获得85%的分成！'],
				outNav:['足球方案','篮球方案','用户关注'],
				newOutIndex:0,
				loadingstr:'加载中',
				pageover:true,
				loading: false, // 加载状态标志位
				uid:0,
				UsersInfo:{},
				tiebaList:[],
				total: 1, //总条数
				page: 1, //当前页数
				limit: 20, //当前条数
				tiebaAttention:[],
				userAttention:[],
				loginDialog:false,
				telDialog:false,
				ruleForm: {
					username: '',
					password: '',
					AuthCode: '',
					token:''
				},
				ruleTelForm:{
				tel:'',
				vcode:'',
				token:''
				},
				codeText:'获取验证码',
				codeTimes:300,
				captchaImg:'',
				phoneCapShow:false,//手机验证码显示
				phone:{
					vcode: '',
					token:''
				},
				nameVal:0,
				UserGuess:[],
				guessCount:{},
				ballBoxItem:{},
				ballTypes:'week',
				circleProVal:0,
				circleBgProVal:0,
				circleMiddleProVal:0,
				times:'',
				proTimes:'',
				middleTimes:'',
				userInfo:{},
				payDialog:false,
				coins:null,
				isRuleShow:false,
				ruleTipList:[],
				ruleVal:'',
			}
		},
		props:{
			 ruleTipLists:{type:Array}
		},
		components:{
			Pagination
		},
		mounted() {
			this.$nextTick(() => {
				const container = document.getElementById('scroll-container');
				window.addEventListener('scroll', this.handleScroll);
			});
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		computed:{
			pubImg(){
				return (thumb)=>{
					if (thumb.indexOf('https')!=-1) {
						return thumb
					} else{
						return (this.GLOBAL.baseUrl+thumb)
					}
				}
			},
			textRep(){
				return (item)=>{
					if (item==undefined||item==null||item=='') return;
					let ind = item.indexOf("<font color=red>*</font>")
					if (ind==-1) {
						return item
					}
					return item.replaceAll("<font color=red>*</font>","受")
				}
			},
			mrs(){
				return (mrsVal)=>{
					if (mrsVal==1) {
						return 'red'
					} else if (mrsVal==2) {
						return 'blue'
					} else if (mrsVal==3) {
						return 'green'
					} else {
					  return '#000'
					}
				}
			},
			numStatus(){
				return (id)=>{
					let userData = JSON.parse(localStorage.getItem('userInfo'));
					if (userData==null) {
						return false;
					}else {
						let focuspub = userData.focuspub
						if (focuspub==null) {
							return false;
						}
						let arr = focuspub.map(item=>{
							let ind = item.indexOf('|')
							return item.substring(0,ind);
						})
						let status = arr.indexOf(id)==-1?false:true
						return status
					}
				}
			},
			uidStatus(){
				return (uid)=>{
					let userData = JSON.parse(localStorage.getItem('userInfo'));
					if (userData==null) {
						return false;
					}else {
						let focususer = userData.focususer
						if (focususer==null) {
							return false;
						}
						let status = focususer.indexOf(uid)==-1?false:true
						return status
					}
				}
			},
			count(){
				return (win_count,match_count)=>{
				  let m = ((win_count/match_count)*100)
				  return parseInt(m)
				}
			},
			tenVals(){
				return (tenVal)=>{
					if (tenVal==1) {
						return 'W'
					} else if(tenVal==2) {
						return 'D'
					} else if(tenVal==3) {
						return 'L'
					}
				}
			},
			tenBgColor(){
				return (tenVal)=>{
					if (tenVal==1) {
						return 'red'
					} else if(tenVal==2) {
						return 'blue'
					} else if(tenVal==3) {
						return 'green'
					}
				}
			},
			isFreeText(){
				return (item)=>{
					if (item==1) {
						return '收费帖'
					} if (item==2) {
						return '预测不中全返'
					} if (item==3) {
						return '关注我即免费'
					}
				}
			},
			saveTagBg(){
				return (key)=>{
					//console.log(key,888)
					switch (key) {
						case 'b':
							return 'lian';
						break;
						case 'c':
							return 'week';
						break;
						case 'd':
							return 'mother';
						break;
						case 'e':
							return 'season';
						break;
						default:
							break;
					}
					
				}
			},
		},
		methods: {
			toRegister(){
				this.$router.push({name:'Register'})
			},
			toArticlePage(id){
				let Detail = this.$router.resolve({name:'ArticlePage',query:{id:id}})
				window.open(Detail.href,'_blank')
			},
			toTiebaDetails(id){
				let Detail = this.$router.resolve({name:'TiebaDetails',query:{id:id}})
				window.open(Detail.href,'_blank')
			},
			toGameTieba(id){
				let Detail = this.$router.resolve({name:'GameTieba',query:{mid:id}})
				window.open(Detail.href,'_blank')
			},
			toUserHome(uid){
				this.$route.query.uid = uid
				let Detail = this.$router.resolve({name:'UserHome',query:{uid:uid}})
				window.open(Detail.href,'_blank')
			},
			changelog(){
				//this.telDialog = false;
				this.loginDialog = true;
			},
			ruleShow(ind){
				 // this.isRuleShow = true
                // console.log(ind,99)
                this.$emit('ruleShowCli',ind)
            },
			//兑换弹框关闭
			payClose(){
				this.payDialog = false
			},
			coinsChange(){
				let tag2 = /^[0-9.]*$/;
				if (!tag2.test(this.coins)||!this.coins) {
				  this.coins = null
				  // this.$message('请输入数字');
				} else {
					let m = this.coins.toString()
					if (m.substring(0,1)=='.'||m.substring(0,1)==0) {
						this.coins = null
					}
				}
			},
			toRecharge(){
				this.$router.push({name:'Recharge'})
			},
			submitPay(){
			  if(!this.coins){
				  this.$message('兑换数量不能为空！')
				  return
			  }
			  let token = localStorage.getItem('token');
			  if(token==''||token==null||token==undefined){
			  	this.$message('请先登录！');
			  	this.getCaptcha()
			  	this.telDialog = true;
			  	return
			  }
			  // return
			  http.post('login/checkToken',{token:token}).then(res=>{
			  	if (res.data.code==90001) {
					let userData = res.data.data.useInfo
					localStorage.setItem('userInfo',JSON.stringify(userData));
					localStorage.setItem('token',userData.token);
			  		http.post('my/changeCoin',{coins:this.coins}).then(res=>{
			  			if (res.data.code==200) {
							// console.log(res.data.data.amount,res.data.data.amount_c);
							// this.openContent = res.data.data.editoropen;
							let userInfo = JSON.parse(localStorage.getItem('userInfo'))
							userInfo.amount =  res.data.data.amount
							userInfo.amount_c =  res.data.data.amount_c
							// console.log(userInfo.amount,userInfo.amount_c,88);
							localStorage.setItem('userInfo',JSON.stringify(userInfo))
							this.userInfo = userInfo;
			  				this.payDialog = false;
							this.$message.success('兑换成功')
							// this.getPayRecode()
			  			}else{
							if(res.data.code == 202){
								this.$confirm(`元宝余额不足,是否充值?`, '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
								}).then(() => {
									this.$router.push({name:'Recharge'})
									// this.$message.error('跳转去充值页面');
								}).catch(() => {
									this.$message('已取消');
								});
							}else{
								this.$message.error(res.data.msg);
							}
			  			}
			  		})
			
			  	}else{
			  		// const store = this.$store;
			  		this.$message(' 用户信息超时,请登录！');
			  		localStorage.clear();
			  		// store.dispatch('getUserInfo',{})
			  		this.$emit('changeActiveStep',false);
			  		this.getCaptcha()
			  		this.telDialog = true;
			  	}
			  })
			},
			changeOutInd(index){
				if (this.newOutIndex == index) return;
				this.newOutIndex = index
				this.page = 1
				if (index==2) {
					this.getUserAttention()
				} else {
					this.getTiebaList()
				}
			},
			isLook(id){
				let token = localStorage.getItem('token');
				if(token==''||token==null||token==undefined){
						this.$message('请先登录！');
						this.getCaptcha()
						this.telDialog = true;
						return
					}
				this.$confirm('是否需要花20Y币查看?', '', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				  http.post('guess/payGuessLook',{id:id}).then(res=>{
					 if (res.data.code===1) {
						this.$message.success(res.data.msg);
						let userData = JSON.parse(localStorage.getItem('userInfo'))
						userData.guesspaylist = res.data.data.guesspaylist;
						userData.amount = res.data.data.amount;
						userData.amount_c = res.data.data.amount_c;
						localStorage.setItem('userInfo',JSON.stringify(userData));
						this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
						console.log(this.userInfo)
						this.getUserGuess()
					 }else if(res.data.code===90002){
						 this.$message(' 用户信息超时,请登录！');
						 localStorage.clear();
						 this.$emit('changeActiveStep',false);
						 this.getCaptcha()
						 this.telDialog = true;
					 }else{
						if(res.data.code == 202){
						  this.$confirm(`${res.data.msg},是否进行元宝兑换Y币?`, '提示', {
						    confirmButtonText: '确定',
						    cancelButtonText: '取消',
						  }).then(() => {
							 this.coins = null
							 this.payDialog = true
						    // this.$message.error('跳转去充值页面');
						  }).catch(() => {
						    this.$message('已取消');
						  });
						}else{
						  this.$message.error(res.data.msg);
						}
					 }
					}).catch(err=>{
					console.log(err);
					})
				}).catch(() => {
				  this.$message({
				    type: 'info',
				    message: '已取消'
				  });          
				});
			},
			// 获取一个新的图形验证码
			getCaptcha() {
				http.get('login/getcaptcha').then(res=>{
					if (res.data.code==1) {
						// console.log(res.data.data);
						this.captchaImg = res.data.data.img
						this.ruleForm.token = res.data.data.token
					}
				})
			},
			getUsersInfo(){
				http.get(`user/getUser/${this.uid}`).then(res=>{
					if (res.data.code==1) {
						this.UsersInfo = res.data.data
						this.UsersInfo.recode.saveTag = res.data.data.recode.saveTag
						// console.log(this.UsersInfo.recode.saveTag,888)
					}

				})
			},
			getUserGuess(){
				http.get(`user/getGuess/${this.uid}/${this.page}/${this.limit}`).then(res=>{
					if (res.data.code==1) {
						this.UserGuess = res.data.data
						let userData = JSON.parse(localStorage.getItem('userInfo'));
						if(!userData||userData.guesspaylist.length==0) return
						let UserGuess = this.UserGuess
						userData.guesspaylist.forEach((item,ind)=>{
							let n = item.split('|')
							// console.log(n);
							UserGuess.forEach((guessVal,guessInd)=>{
								if (item.split('|')[0]==guessVal.id) {
									// console.log(44,guessInd,item.split('|')[0]);
									UserGuess[guessInd].isPay = 1
									UserGuess[guessInd].rtype = n[1]
								}
							})
						})
						// this.UserGuess = UserGuess
						// console.log(UserGuess,66);
					}

				})
			},
			getGuessCount(){
				http.get(`user/getGuessCount/${this.uid}`).then(res=>{
					if (res.data.code==1) {
						this.guessCount = res.data.data;
						this.changeCount('week')
					}
				})
			},
			changeCount(types){
				this.ballTypes=types
				this.ballBoxItem = {}
				this.circleProVal = 0
				this.circleBgProVal = 0
				this.circleMiddleProVal = 0
				if (types=='week') {
					this.ballBoxItem = this.guessCount.week
				} else if (types=='month') {
					this.ballBoxItem = this.guessCount.month
				} else if (types=='qua') {
					this.ballBoxItem = this.guessCount.quarter
				}
				clearInterval(this.times)
				clearInterval(this.proTimes)
				clearInterval(this.middleTimes)
				let ballBoxItem = this.ballBoxItem
				if (ballBoxItem.a.match_count!=0 || ballBoxItem.b.match_count!=0) {
					this.times = setInterval(()=>{
						if (this.circleBgProVal<100) {
							this.circleBgProVal+=10
						} else{
							this.circleBgProVal = 100
							clearInterval(this.times)
						}
					},300)
				}
				let n;
				if (ballBoxItem.a.win_count!=0 || ballBoxItem.b.win_count!=0) {
					let m = ((ballBoxItem.a.win_count + ballBoxItem.b.win_count)/((ballBoxItem.a.match_count + ballBoxItem.b.match_count)-(ballBoxItem.a.ping_count + ballBoxItem.b.ping_count)))*100
					console.log(((ballBoxItem.a.ping_count + ballBoxItem.b.ping_count)),8877)
					n = Math.round(m)
					let i;
					this.proTimes = setInterval(()=>{
						i = n-Number(this.circleProVal)
						if (i<10) {
							this.circleProVal+=(n-Number(this.circleProVal))
						} else if (this.circleProVal<n) {
							this.circleProVal+=10
						} else{
							this.circleProVal = n
							clearInterval(this.proTimes)
						}
					},400)
				}
				if (ballBoxItem.a.ping_count!=0 || ballBoxItem.b.ping_count!=0) {
					console.log(ballBoxItem.a.ping_count,ballBoxItem.b.ping_count,99);
					let k = ((ballBoxItem.a.ping_count + ballBoxItem.b.ping_count)/(ballBoxItem.a.match_count + ballBoxItem.b.match_count))*100
					let j = Math.round(k)
					let l;
					console.log(k,j,88);
					if (j<n) {
						j+=n
					}
					this.middleTimes = setInterval(()=>{
						l = j-Number(this.circleMiddleProVal)
						if (l<10) {
							this.circleMiddleProVal+=(j-Number(this.circleMiddleProVal))
						} else if (this.circleMiddleProVal<j) {
							this.circleMiddleProVal+=10
						} else{
							this.circleMiddleProVal = j
							clearInterval(this.middleTimes)
						}
					},350)
				}
			},
			getTiebaList(){
				this.pageover = true;
				this.loading = false;
				http.get(`user/getTheme/${this.uid}/${this.newOutIndex+1}/${this.page}/${this.limit}`).then(res=>{
					if (res.data.code==1) {
						this.total = res.data.data.count
						this.tiebaList = res.data.data.list
					}else{
						this.pageover = false;
						this.loading = false;
						this.tiebaList = [];
					}

				})
			},
			pageChange(e) {
			  //接收分页页面传过来的页数并调用logInfo再次渲染日志页面
			  this.page = e;
			  this.loading = true;
			  this.getTiebaList();
			},
			limitChange(e) {
			  //接收分页页面传过来的条数并调用logInfo再次渲染日志页面
			  this.limit = e;
			  this.loading = true;
			  this.getTiebaList();
			},
			getTiebaAttention(){
				http.get(`user/getFocusPub/${this.uid}`).then(res=>{
					if (res.data.code==1) {
						this.tiebaAttention = res.data.data
					}

				})
			},
			getUserAttention(){
				http.get(`user/getFocusUser/${this.uid}`).then(res=>{
					if (res.data.code==1) {
						this.userAttention = res.data.data
					}

				})
			},
			//关注
			interest(id,types){
				let token = localStorage.getItem('token');
				if(token==''||token==null||token==undefined){
					this.$message('请先登录！');
					this.getCaptcha()
					this.telDialog = true;
					return
				}
				http.post('login/checkToken',{token:token}).then(res=>{
					if (res.data.code==90001) {
						let userData = res.data.data.useInfo
					localStorage.setItem('userInfo',JSON.stringify(userData));
					localStorage.setItem('token',userData.token);
						if (types=='user') {
							let userStatus = this.uidStatus(id)?0:1
							http.post('user/focusUser',{uid:id,status:userStatus}).then(res=>{
								if (res.data.code==1) {
									this.$message.success(res.data.msg);
									let userData = JSON.parse(localStorage.getItem('userInfo'));
									userData.focususer = res.data.data.focususer
									localStorage.setItem('userInfo',JSON.stringify(userData));
									this.getUsersInfo()
									this.getUserAttention()
								}else{
									this.$message.error(res.data.msg);
								}
							})
						} else{
							let status = this.numStatus(id)?0:1
							let userData = JSON.parse(localStorage.getItem('userInfo'));
							http.post('pub/focusPub',{pid:id,status:status,uid:userData.id,token:localStorage.getItem('token')}).then(res=>{
								if (res.data.code==1) {
									this.$message.success(res.data.msg);
									userData.focuspub = res.data.data.focuspub
									localStorage.setItem('userInfo',JSON.stringify(userData));
									this.getTiebaAttention()
								}else{
									this.$message.error(res.data.msg);
								}
							})
						}

					}else{
						// const store = this.$store;
						this.$message(' 用户信息超时,请登录！');
						localStorage.clear();
						// store.dispatch('getUserInfo',{})
						this.$emit('changeActiveStep',false);
						this.getCaptcha()
						this.telDialog = true;
					}
				})
			},
			//登录弹框关闭
			loginClose(){
				this.ruleForm = {
					username: '',
					password: '',
					AuthCode: ''
				};
				this.loginDialog = false;
				this.ruleTelForm={
					tel:'',
					vcode:'',
					token:''
				};
				this.telDialog = false;
			},
			//登录弹框
			submitForm(){
				let reg1 = /^[a-zA-Z0-9]{6,}$/;
				let reg2 = /^[0-9]{11}$/;
				if (!this.ruleForm.username) {
					return this.$message({
						message:'手机号不能为空！',
						type: 'warning'
					});
				}
				if (!this.ruleForm.password) {
					return this.$message({
						message:'密码不能为空！',
						type: 'warning'
					});
				}else if(!reg1.test(this.ruleForm.password)){
					return this.$message({
						message:'请输入至少6位的英文或数字设置密码！',
						type: 'warning'
					});
				}
				if (!this.ruleForm.AuthCode) {
					return this.$message({
						message:'验证码不能为空！',
						type: 'warning'
					});
				}
				if (this.phoneCapShow) {
					if (!this.phone.vcode) {
						return this.$message({
							message:'手机验证码不能为空！',
							type: 'warning'
						});
					}
				}
				//验证手机验证码
				if (this.phoneCapShow) {
					http.post('login/checkVcode',{...this.phone}).then(res=>{
						 if (res.data.code==1) {
							this.login('1')
						 }else{
							 this.$message.error(res.data.msg);
						 }
					}).catch(err=>{
						console.log(err);
					})
				}else {
					this.login('0')
				}
			},
			submitTel(){
				let reg2 = /^[0-9]{11}$/;
				if (!this.ruleTelForm.tel) {
					return this.$message({
						message:'手机号不能为空！',
						type: 'warning'
					});
				}else if(!reg2.test(this.ruleTelForm.tel)){
					return this.$message({
						message:'请输入11位的手机号码！',
						type: 'warning'
					});
				}
				if (!this.ruleTelForm.vcode) {
					return this.$message({
						message:'手机验证码不能为空！',
						type: 'warning'
					});
				}
				http.post('login/regBytel',{...this.ruleTelForm}).then(res=>{
					 if (res.data.code===1) {
						this.ruleTelForm = {
							// username: '',
							// password: '',
							tel:'',
							vcode: '',
							token:''
						};
						this.$message({
							message:res.data.msg,
							type: 'success'
						});
						this.telDialog = false;
						//token储存
						localStorage.setItem('token',res.data.data.token)
						let val = res.data.data;
						
						// store.dispatch('getUserInfo',res.data.data)
						localStorage.setItem('userInfo',JSON.stringify(res.data.data))
						this.$emit('changeUser',val);
						//let cookData = {token:val.token,username:encodeURIComponent(val.username),saveDingzhi:val.saveDingzhi,saveGongNeng:val.saveGongNeng,level:val.level,zsvip:val.zsvip,zsvipTime:val.zsvipTime,id:val.id,thumb:val.thumb,amountAll:val.amountAll,coupons:val.coupons,couponsCount:val.couponsCount,couponsTime:val.couponsTime};
						//_this.$cookie.set('userInfo', JSON.stringify(val),{ expires: 1, domain:'yingtiyu.com'})
						_this.$cookie.set('userInfo', val.token,{ expires: 1, domain:'.yingtiyu.com'});
						this.$router.go(0)
					 }else{
						 this.$message.error(res.data.msg);
					 }
				}).catch(err=>{
					console.log(err);
				})

			},
			toLogin(){
				this.$router.push({name:'Login'})
			},
			login(nameVal){
				//登录
				let _this = this;
				http.post('login/logonAjax',{...this.ruleForm,is_succ: nameVal}).then(res=>{
					 if (res.data.code===1) {
						this.ruleForm = {
							username: '',
							password: '',
							AuthCode: ''
						};
						this.$message.success(res.data.msg);
						this.loginDialog = false
						//token储存
						localStorage.setItem('token',res.data.data.token)
						let val = res.data.data;
						//let cookData = {token:val.token,username:encodeURIComponent(val.username),saveDingzhi:val.saveDingzhi,saveGongNeng:val.saveGongNeng,level:val.level,zsvip:val.zsvip,zsvipTime:val.zsvipTime,id:val.id,thumb:val.thumb,amountAll:val.amountAll,coupons:val.coupons,couponsCount:val.couponsCount,couponsTime:val.couponsTime};
						//_this.$cookie.set('userInfo', JSON.stringify(val),{ expires: 1, domain:'yingtiyu.com'})
						_this.$cookie.set('userInfo', val.token,{ expires: 1, domain:'.yingtiyu.com'});
						// store.dispatch('getUserInfo',res.data.data)
						localStorage.setItem('userInfo',JSON.stringify(res.data.data))
						this.$router.go(0)
					 }else{
						 if (res.data.data.length>0) {
						 	this.ruleForm.username = res.data.data[0];
						 	this.phoneCapShow = true;
						 }else{
							 if (!this.phoneCapShow) {
							 	this.getCaptcha()
							 }
						 }
						 this.$message.error(res.data.msg);
					 }
				}).catch(err=>{
					console.log(err);
				})
			},
			//获取验证码
			getCode(){
				let userName = (this.ruleForm.username) ? this.ruleForm.username : this.ruleTelForm.tel ;
				let reg2 = /^[0-9]{11}$/;
				if (!userName) {
					return this.$message({
						message:'手机号不能为空！',
						type: 'warning'
					});
				}
				if(!reg2.test(userName)){
					return this.$message({
						message:'请输入11位的手机号码！',
						type: 'warning'
					});
				}
				http.post('login/getVcode',{tel:userName}).then(res=>{
					 if (res.data.code===1) {
						 this.phone.token = res.data.data.token
						 this.ruleTelForm.token = res.data.data.token
					 	this.$message.success(res.data.msg)
						this.codeText = this.codeTimes+'s'
						let times =  setInterval(()=>{
							if (this.codeTimes<=0) {
								clearInterval(times)
								this.codeText = '获取验证码'
							} else{
								this.codeTimes--
								this.codeText = this.codeTimes+'s'
							}
						},1000)
					 }else{
						 this.$message.error(res.data.msg);
					 }
				}).catch(err=>{
					console.log(err);
				})
			},
			handleScroll() {
				const container = document.getElementById('scroll-container');
				const rect = container.getBoundingClientRect();
				const scrollTop = rect.top;
				const scrollHeight = container.scrollHeight;
				const clientHeight = container.clientHeight;
				const scrollBottom = scrollHeight + scrollTop - window.innerHeight;
				if (scrollBottom <= 0) {
					
				// 滚动到底部，加载下一页数据
				this.loadNextPage();
				}
			},
			loadNextPage() {
				if(!this.pageover){
					this.loadingstr = '已经没有更多的数据了';
					this.loading = true; 
				}
				if (this.loading) return; // 如果正在加载中，则不执行新的加载请求
    			this.loading = true; // 设置加载状态为true
				this.page++;
				if(this.newOutIndex!=2){
					this.getTiebaListAdd();
				}
				

			},
			getTiebaListAdd(){
				http.get(`user/getTheme/${this.uid}/${this.newOutIndex+1}/${this.page}/${this.limit}`).then(res=>{
					if (res.data.code==1) {
						if(res.data.data.list.length == 0){
							this.pageover = false;
							this.loading = false;
						}
						this.total = res.data.data.count;
						//this.topicList = res.data.data.list
						this.tiebaList = [...this.tiebaList, ...res.data.data.list];
						//console.log(this.topicList,88)
						this.loading = false; // 加载完成后，将加载状态设置为false
						
					}else{
						this.pageover = false;
						this.loading = false;
					}
					

				})
			},
		}
	}
</script>

<style scoped>
	.navhengfu {
		background: url('@/static/icons/hengfu.png') center center no-repeat;
		height: 52px;
		position: absolute;
		width: 1900px;
		top:70px;
		line-height: 52px;
		font-size: 16px;
		cursor: pointer;

	}

	.navhengfu .navtxt {
		padding-left:20px;
		background: url('@/static/icons/notice.png') left center no-repeat;
		color:red;
	}
	.userHome {
		overflow: hidden;
		display: flex;
		justify-content: center;
		flex-wrap: nowrap;
		padding-top: 55px;
		margin-bottom: 20px;
	}

	.notice {
		font-size: 14px;
		color: #E83655;
		text-align: right;
		height: 18px;
		line-height: 18px;
		width: 1200px;
		display: flex;
		align-items: center;
		position: absolute;
		top: 76px;
		justify-content: right;
	}

	.notice img {
		width: 13px;
		height: 13px;
		margin-right: 4px;
	}

	.lunbo {
		padding: 0 8px 0 0;
		box-sizing: border-box;
		height: 35px;
		line-height: 35px;
		text-overflow: ellipsis;
		word-break: keep-all;
		white-space: nowrap;
		overflow: hidden;
		flex: 1;
		width: 200px;
	}
	.lunbo /deep/ .el-carousel__indicator--vertical {
		padding: 0;
		width: 0;
	}
	.lunbo /deep/ .el-carousel__container {
		height: 35px;
	}
	.lunbo.el-carousel.el-carousel--vertical {
		width: 200px!important;
	}

	.ruleShow /deep/ .el-dialog {
		/* height: 500px; */
		overflow: auto;
	}
	.ruleShow /deep/ .el-dialog__body {
		color: #000;
		line-height: 22px;
		text-align: left;
		font-size: 15px;
	}
	.ruleShow /deep/ .el-dialog__body p:first-child {
		font-size: 18px;
	}
	.ruleShow /deep/ .el-dialog__header {
		padding: 0;
	}
	.ruleShow /deep/ .el-dialog__footer {
		padding: 0 20px;
		line-height: 22px;
		margin-bottom: 20px;
	}

	.payshow{
	   line-height: 30px;
	 }
	 .payshow /deep/ .el-dialog,.settingBox /deep/ .el-dialog {
		  width: 455px;
		  border-radius: 12px 50px 12px 50px;
	 }
	 .payshow /deep/ .el-dialog__header,.settingBox /deep/ .el-dialog__header {
		  line-height: 40px;
		  padding: 0;
		  background: url('@/static/img/showHeadBg.png') no-repeat;
		  background-size: 100% 100%;
	 }
	 .payshow /deep/ .el-dialog__header .el-dialog__title,.settingBox /deep/ .el-dialog__header .el-dialog__title {
		  color: #fff;
	 }
	 .payshow /deep/ .el-dialog__body div {
		font-size: 15px;
		color: #343434;
		white-space: normal;
	 }
	 .payshow /deep/ .el-dialog__body div:last-child {
	 	font-size: 12px;
	 	color: #7E7E80;
	 }
	 .payshow /deep/ .el-dialog__body div span {
		white-space: nowrap;
	 	color: #EC7001;
	 }
	 .payshow /deep/ .el-dialog__body div a {
		 color: #0F72FA;
		 font-size: 13px;
		 margin-left: 10px;
		 cursor: pointer;
		 text-decoration: underline;
	 }
	 .payshow /deep/ .el-dialog__body div.detailBox {
		border-top: #ccc 1px dashed;
		padding-top: 10px;
		margin-top: 10px;
	 }
	 .payshow /deep/ .el-dialog__body p {
		 margin: 0;
		 /* height: 18px; */
		 font-size: 13px;
		 color: #666;
		 line-height: 18px;
		 text-align: left;
		 margin-left: 20px;
	 }
	 .payshow /deep/ .el-dialog__body div:last-child span {
	 	color: #4768FB;
	 }
	 .payshow /deep/ .el-dialog__body .el-button--primary,.settingBox /deep/ .el-dialog__body .el-button--primary {
		  width: 180px;
		  height: 36px;
		  line-height: 36px;
		  padding: 0;
		  background: linear-gradient(0deg, #33A8FF 0%, #4768FB 99%);
		  border-radius: 8px;
		  margin-top: 20px;
	 }
	.payshow /deep/  .el-dialog__headerbtn,.settingBox /deep/ .el-dialog__headerbtn {
		  top: 11px;
	 }
	 .payshow /deep/ .el-dialog__headerbtn .el-dialog__close,.settingBox /deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	 }
	.loginShow /deep/ .el-dialog {
		width: 380px;
	}
	.loginShow /deep/ .el-dialog__header {
		height: 60px;
		line-height: 60px;
	}
	.loginShow /deep/ .el-dialog__title {
		font-size: 26px;
		color: #2882FE;
	}
	.loginShow /deep/ .el-dialog__body {
		padding: 30px 10%;
	}
	.loginShow /deep/ .el-input--prefix .el-input__inner {
		padding-left: 40px;
	}
	.loginShow /deep/ .el-input__prefix img {
		margin: 9px 0  0 5px;
	}
	.loginShow .phoneCode /deep/ .el-input__suffix{
		display: flex;
		right: 2px;
	}
	.loginShow .phoneCode /deep/ .el-input__suffix-inner {
		margin: auto;
		cursor: pointer;
		height: 4vh;
	}
	.loginShow .phoneCode /deep/ .el-input__suffix-inner img {
		height: 4vh;
	}
	.loginShow .phoneBox /deep/ .el-input__suffix {
		right: 0px;
	}
	.loginShow .phoneCap {
		background: #2882FE;
		color: #fff;
		height: 4.3vh;
		line-height: 4.3vh;
		white-space: nowrap;
		padding: 0 2.3vw;
		box-sizing: border-box;
		border: 1px solid #E9E9E9;
		border-radius: 4px;
		cursor: pointer;
		font-size:calc(100vw * 15 / 1920);
	}
	.loginShow .loginBtn {
		width: 100%;
		background: #2882FE;
		font-size: 17px;
		margin-top: 20px;
	}
	.loginShow .forgotPwd {
		margin-top: 10px;
		width: fit-content;
		color: #666666;
		line-height: 16px;
		font-size: 13px;
		cursor: pointer;
	}
	.loginShow .toRegister {
		margin-top: 50px;
		text-align: center;
		color: #666666;
		line-height: 16px;
		font-size: 14px;
		cursor: pointer;
	}
	.loginShow .toRegister span {
		color: #2882FE;
	}
	.loginShow /deep/ .el-form-item:last-child {
		margin-bottom: 0;
	}

	.myGuessBox {
		margin-bottom: 32px;
		padding: 0 15px;
		position: relative;
	}
	.myGuessBox .circleProgree {
		position: absolute;
		right: 100px;
		top: 0;
		display: flex;
		height: 130px;
	}
	.myGuessBox .circleProgree .ProBox {
		position: relative;
	}
	.myGuessBox .circleProgree .circleProBg {
		position: absolute;
		left: 0;
		top: 0;
	}
	.el-progress >>> svg path:first-child {
		stroke: rgba(240, 243, 247, 0.3)!important;
	}
	.myGuessBox .circleProgree .ProBox .text-wrap {
		position: absolute;
		line-height: 10px;
		top: 46px;
		left: 39px;
	}
	.myGuessBox .circleProgree .ProBox .text-wrap p {
		color: red;
	}
	.myGuessBox .circleProgree .circleBox {
		display: flex;
		flex-wrap: wrap;
		height: 80px;
		line-height: 40px;
		margin: auto;
	}
	.myGuessBox .circleProgree .circleBox div {
		width: 100%;
		line-height: 40px;
		font-size: 13px;
	}
	.myGuessBox .circleProgree .circleBox div span {
		border: #ccc 1px solid;
		padding: 5px;
		font-size: 14px;
		margin-right: 4px;
		border-radius: 8px;
	}
	.myGuessBox .circleProgree .circleBox div:last-child span {
		color: #FFA400;
	}
	.statisticsList {
		line-height: 24px;
		display: flex;
		align-items: center;
		margin-bottom: 46px;
	}
	.statisticsList .title,.BillboardTitle {
		margin-right: 60px;
		color: #333333;
		font-size: 16px;
	}
	.statisticsList .selectList {
		display: flex;
		align-items: center;
		line-height: 22px;
	}
	.statisticsList .selectList span {
		width: 65px;
		text-align: center;
		border: 1px solid #ccc;
		background: #FFFFFF;
		color: #333333;
		font-size: 13px;
		box-sizing: border-box;
	}
	.statisticsList .selectList span:hover {
		cursor: pointer;
	}
	.statisticsList .selectList span.isCli {
		background: #ECEDFC;
		color: #1169FF;
		border: none;
		line-height: 24px;
	}
	.ballBox {
		display: flex;
		align-items: center;
		line-height: 17px;
		font-size: 13px;
		color: #333333;
		margin-bottom: 10px;
	}
	.ballBox span {
		margin-right: 16px;
		text-align: left;
	}
	.ballBox span:first-child {
		width: 40px;
	}
	.ballBox span:nth-child(2) {
		width: 260px;
		overflow: hidden;
		white-space: nowrap;
	}
	.ballBox span span {
		color: #442fff;
	}
	.ballBox span span:first-child {
		color: #EE0930;
	}
	.ballBox span span:last-child {
		color: #03FE47;
	}
	.progree{
		display: inline-block;
		width: 275px;
	}
	.progree /deep/ .el-progress-bar__inner {
		background: linear-gradient(90deg, #F05F06 0%, #FF9B01 100%);
	}
	.twoPro.progree /deep/ .el-progress-bar__inner {
		background: linear-gradient(90deg, #404FD3 0%, #5D6DF9 100%);
	}
	.BillboardItem span.isImp{
		background-image: url('@/static/icons/pointicon.png');
		background-repeat: no-repeat;
		background-position: right top;
	}
	.topicsCent{
		position: relative;
	}
	.topicsCent .match {
		color: #fff;
		font-size: 14px;
		/* width: 320px; */
		white-space: nowrap;
	}
	.topicsCent .match span {
		/* padding: 2px; */
		width: 17px;
		line-height: 17px;
		display: inline-block;
		color: #FFFFFF;
		font-size: 12px;
		background: #2C35EB;
		border-radius: 50%;
		text-align: center;
		margin: 0 3px;
	}
	.saveTagBox {
		position: relative;
		/* left: -30px; */
		white-space: nowrap;
	}
	.saveTagBox span {
		text-align: center;
		margin-right: 4px;
		color: #62b0ed;
		border: 1px solid #cde9ff;
		background-color: #f3f9fd;
		border-radius: 10px;
		line-height: 18px;
		padding: 0 6px;
		font-size: 12px;
	}
	.saveTagBox span.lian {
		color: #ff5107;
		border: 1px solid #ffdacb;
		background-color: #fff8f7;
	}
	.saveTagBox span.season {
		color: #f16529;
		background-color: #FAF3E7;
    	border: 1px solid #e2a47d;
	}
	.saveTagBox span.mother {
		color: #008000;
		background-color: #F4FCE9;
   		border: 1px solid #D5E7BC;
	}
	.saveTagBox span.week {
		border: solid 1px #f7c9a4;
		background-color: #fffbf3;
		color: #cd8663;
	}
	/* 空数据 */
	.myGuessBox .emtype {
		display: flex;
		justify-content: left;
		align-items: center;
		flex-wrap: wrap;
	}
	.myGuessBox .emtype img {
		width: 220px;
	}
	/* 空数据 */
	.emtype {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}
	.emtype div {
		line-height: 22px;
		width: 100%;
		color: #666;
		font-size: 14px;
	}
	.BillboardTitle {
		margin-right: 60px;
		color: #333333;
		font-size: 16px;
		margin: 40px 0 20px;
		line-height: 22px;
		text-align: left;
		padding-left: 15px;
	}

	.main {
		width: 1200px;
		overflow: hidden;
	}
	.userNav {
		background-color: #fff;
	}
	.tabs {
		line-height: 35px;
		padding: 0 30px;
		display: flex;
		align-items: center;
		position: relative;
		margin-bottom: 10px;
	}
	.tabs span {
		margin-right:40px;
		color: #666;
		font-size: 15px;
	}
	.tabs span.isSecte{
		border-bottom: 2px solid #0A54D6;
		color: #0A54D6;
		font-weight: bold;
	}
	.tabs span:hover {
		color: #0A54D6;
		cursor: pointer;
		font-weight: bold;
	}
	.gameTopicList /deep/ .el-pagination {
		position: absolute;
		width: 100%;
		bottom: 0;
		box-sizing: border-box;
	}

	.paycoin {
		display: block;
		
		min-width: 80px;
	
		color: white;
		line-height: 30px;
		font-size: 13px;
		text-align: center;
		border-radius: 10px;
		background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);
		text-decoration: none;
		text-transform: uppercase;
		background-size: 400%;
		z-index: 1;
		font-weight: normal;
		padding: 4px;
	}
	.paycoin:hover {
	    /* animation要和@keyframes搭配使用，move是随意起的一个动画名称，也是@keyframes规则的名称，
	       8s表示一个循环，infinite表示无限循环下去，alternate表示动画会在每次循环之间交替反向播放 */
	    animation: move 8s infinite alternate;
	}
	@keyframes move {
	    /* 100%表示最终时间达到位置，%0可以省略，默认初始 */
	    100% {
	        background-position: -400% 0;
	    }
	}
	.paycoin:before {
	    content: "";
	    position: absolute;
	    left: -5px;
	    right: -5px;
	    top: -5px;
	    bottom: -5px;
	    /* 以下三个和a元素保持一致 */
	    /*background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);*/
	    background-size: 400%;
	    border-radius: 50px;
	    /* 将元素内容模糊化 */
	    filter: blur(20px);
	    z-index: -1;
	}
	.paycoin:hover:before {
	    animation: move 8s infinite alternate;
	}

	/* 赛事方案列表 */
	.topicBox {
		border-radius: 10px;
	}

	.topicsCent {
		padding: 16px;
		border-radius: 10px 10px 0 0;
		background: linear-gradient(179deg, #0A54D6 0%, #5B8CE4 100%);
		display: flex;
	}

	.topicsCentLeft {
		margin-right: 20px;
		width: 80px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	.topicsCentLeft img {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}

	.topicsCentLeft span {
		line-height: 21px;
		color: #E5E2E2;
		font-size: 12px;
		width: 100%;
	}

	.topicsCentLeft span:last-child {
		font-weight: bold;
		font-size: 13px;
		white-space: nowrap;
		max-width: 70px;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.topicsCentRight {
		display: flex;
		flex-wrap: wrap;
		text-align: left;
		/* height: 72px; */
	}

	.topicsCentRight .detail {
		width: 100%;
		color: #FFFFFF;
		font-size: 15px;
		line-height: 22px;
		/* height: 44px; */
	}
	
	.topicsCentRight .boxText {
		/*display: flex;
		align-items: center;*/
		width:100%;
	}

	.topicsCentRight .topicsCentNav {
		line-height: 20px;
		color: #E6E6E6;
		font-size: 12px;
		display: flex;
		align-items: center;
		margin-left: 20px;
		float:right;
		position: absolute;
		right: 20px;
		bottom: 4px;
	}

	.topicsCentRight .topicsCentNav span {
		color: #F9A20C;
		font-size: 12px;
		margin-right: 20px;
	}

	.topicsCentRight .topicsCentNav div:last-child {
		padding: 0 6px;
		line-height: 19px;
		background: #FAB75D;
		color: #FEFEFE;
		border-radius: 12px;
	}
	.topicsCentRight .topicsCentNav div:last-child.grcyInterest {
		background-color: #ccc;
	}
	.topicsCentRight .topicsCentNav div:last-child:hover {
		cursor: pointer;
	}

	.gameTopicList {
		background-color: #fff;
		min-height: 500px;
		position: relative;
	}

	.gameTopicItem {
		padding: 16px 10px;
		display: flex;
		justify-content: space-between;
		align-items: start;
	}
	.gameTopicItem:hover {
		cursor: pointer;
	}

	.gameTopicItem .outbox {
		display: flex;
	}

	.gameTopicItem:hover {
		background: rgba(67, 124, 224, 0.22);
	}

	.gameTopicItem .userImg {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin: 9px 20px 0 20px;
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}

	.gameTopicCent {
		line-height: 40px;
		text-align: left;
	}

	.gameTopicCent .gameCentTitle {
		color: #0A54D6;
		line-height: 22px;
		font-weight: bold;
		font-size: 17px;
	}

	.gameTopicCent .gameCentNum {
		color: #444545;
		font-size: 13px;
		display: flex;
		align-items: center;
	}

	.gameTopicCent .gameCentNum span:first-child {
		line-height: 20px;
		background: #0A54D6;
		border-radius: 10px;
		padding: 0 15px;
		font-size: 13px;
		color: #fff;
		margin-right: 18px;
	}

	.gameTopicCent .gameCentNum span:nth-child(n+3):hover {
		text-decoration: underline;
		color: #0A54D6;
	}

	.gameTopicCent .gameCentNum /deep/ .el-divider--vertical {
		height: 10px;
		background: #B6CBF0;
		margin: 0 14px;
	}

	.watchNum {
		color: #707070;
		font-size: 13px;
		line-height: 32px;
		margin-right: 30px;
		text-align: right;
	}

	.watchNum img {
		width: 18px;
		height: 12px;
		margin-right: 8px;
	}

  .lookcoin {
  	color: #fb8c00;
  	font-size: 13px;
  	line-height: 32px;
  	margin-right: 30px;
  	text-align: right;
   
    float: right;
	/*
	height: 32px;
    width: 66px;
    background: url(@/static/icons/vcoin.png) left center no-repeat;
	*/
  }

	.times {
		line-height: 22px;
		font-size: 13px;
		color: #999;
		margin-right: 30px;
		text-align: right;
	}

	.myAttentionBox {
		padding: 20px;
		overflow: hidden;
	}
	.myAttentionItem {
		width: 27%;
		float: left;
		margin-right: 60px;
		margin-bottom: 15px;
		padding: 15px;
		display: flex;
		justify-content: space-between;
		align-items: self-end;
		background: rgba(255, 255, 255, 0.1);
		box-shadow: -1px 5px 38px 1px rgba(4,0,0,0.03);
		border-radius: 6px;
		border: 1px solid rgba(204, 204, 204, 0.1);
	}
	.myAttentionItem:hover {
		background: rgba(46, 50, 246, 0.1);
		box-shadow: -1px 5px 38px 1px rgba(4,0,0,0.03);
		border-radius: 6px;
		cursor: pointer;
	}
	.myAttentionItem:nth-child(3n){
		margin-right: 0;
	}
	.myAttentionItem .tiebaImg {
		width: 45px;
		height: 45px;
		border-radius: 50%;
		margin-right: 17px;
		image-rendering: -webkit-optimize-contrast; /* 处理模糊代码 */
	}
	.myAttentionItem .tiebaBox {
		display: flex;
		flex-wrap: wrap;
		line-height: 23px;
		text-align: left;
		color: #999999;
		font-size: 13px;
	}
	.myAttentionItem .tiebaBox div {
		width: 100%;
	}
	.myAttentionItem .tiebaBox div.tiebaNum{
		width: 130px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.myAttentionItem .tiebaBox .tiebaName {
		color: #5C5C5C;
		font-size: 15px;
		width: 160px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.myAttentionItem .tiebaBox span {
		color: #1D42FE;
	}
	.myAttentionItem .takeOff {
		line-height: 25px;
		color: #FEFEFE;
		font-size: 12px;
		padding: 0 10px;
		background: #FAB75D;
		border-radius: 9px;
		margin-bottom: 2px;
		white-space: nowrap;
	}
	.myAttentionItem .takeOff.grcyInterest {
		background-color: #ccc;
	}

	.billboardbox {
		padding: 10px;
	}
	.billboardItem {
		background-color: #fff;
	}
	.BillboardItem /deep/ .el-button--small.is-round {
		padding: 7px 20px
	}
	.BillboardItem /deep/ .el-button.is-round {
		border-radius: 15px;
	}
	.BillboardNav {
		height: 40px;
		line-height: 40px;
		background-color: #fbfbfb;
		font-size: 14px;
		color: #4D4D4D;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 15px;
		border-bottom: #0A54D5 1px solid;
	}
	.BillboardNav span {
		width: 15%;
	}
	.BillboardNav span:last-child {
		width: 30%;
		font-weight: bold;
	}
	.BillboardItem {
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #000;
		font-size: 13px;
		margin: 0 15px;
		border-bottom: #EEEEEE 1px solid;
	}
	.gameTopicList /deep/  .Pagin {
		height: 90px;
	}
	.BillboardItem:nth-child(2n) {
		background-color: #fbfbfb;
	}
	.BillboardItem:hover {
		cursor: pointer;
		background: #EEF4FD;
	}
	.BillboardItem span {
		width: 15%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		height: 40px;
	}
	.BillboardItem span:first-child {
		color: #ffff;
	}
	.BillboardItem span:nth-child(4){
		color: #FF5106;
		font-weight: bold;
	}
</style>
